module.exports = __webpack_public_path__ + "static/media/noResultsContact.b53b80cd.png";